<template><svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><circle stroke="#000" fill="none" opacity=".16" cx="6" cy="6" r="5.5"/></svg></template>